import React from 'react';

import classNames from 'classnames';

import { LayoutExtension } from '../../types/ResponsiveState';
import { Typography } from '../Typography/Typography';
import styles from './HeroTitle.module.css';

export type Props = {
  children: string;
  className?: string;
  isEnabledDynamicalSize?: boolean;
  layoutExtension: LayoutExtension;
};

export const HeroTitle = React.memo((props: Props) => {
  const {
    children,
    className,
  } = props;

  const wrapperClass = React.useMemo(() =>
    classNames(
      styles.heroTitle,
      className,
    ), [className]);

  return (
    <Typography
      className={wrapperClass}
      variant='h1'
    >
      {children}
    </Typography>
  );
});

HeroTitle.displayName = 'HeroTitle';
